import { PropTypes } from "base/react-libs";
import { Icon, Button } from "@evertrue/et-components";
import { useEffect, useState } from "react";
import { fetchContactInfoById } from "apps/journeys/utils/api-requests/hooks/recommended-actions/use-recommended-actions-requests";
import RecommendedActionRow from "./recommended-action-row";

// just for the demo
const FAKE_JOBS = [
  { title: "Managing Director", company: "Calliope Investment Partners", reported: "February 3rd", confidence: "High" },
  { title: "Chair, Orthopedic Surgery", company: "Northwestern Medicine", reported: "March, 4th", confidence: "High" },
  { title: "Senior Partner", company: "Price, Waterhouse, Cooper", reported: "April, 1st", confidence: "Medium" },
  { title: "Associate Attorney", company: "ANST & Associates LLP ", reported: "February, 16th", confidence: "Medium" },
  { title: "Senior Software Engineer", company: "Apple", reported: "March, 24th", confidence: "Low" },
];

const RecommendedActionSection = ({
  title,
  subtitle,
  recommendedActions = [],
  icon,
  iconKit = "gt2",
  type = "gift",
}) => {
  const [recommendations, setRecommendations] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchAllContacts = async () => {
      if (!recommendedActions.length) return;

      const actionsWithContacts = await Promise.all(
        recommendedActions.map(async (action) => {
          const contact = await fetchContactInfoById(action.contact_id, false);
          contact.job = FAKE_JOBS[Math.floor(Math.random() * FAKE_JOBS.length)]; // TODO: REMOVE FAKE DATA FOR DEMO
          action.contact = contact || {};
          return action;
        })
      );
      setRecommendations(actionsWithContacts.filter((action) => !!action.contact.id));
    };
    fetchAllContacts();
  }, [recommendedActions]);

  return (
    <>
      <div className="homepage-recommendations-section-title">
        <Icon icon={icon} iconKit={iconKit} />
        <h6>{title}</h6>
      </div>
      <div>
        {recommendations.slice(0, showAll ? recommendations.length : 3).map(({ id, viewed, contact = {} }, index) => (
          <RecommendedActionRow
            id={id}
            key={id}
            type={type}
            viewed={viewed}
            contact={contact}
            first={index === 0}
            subtitle={subtitle}
          />
        ))}
        {recommendations.length > 3 && (
          <div style={{ paddingBottom: "8px" }}>
            <Button type="simple" onClick={() => setShowAll(!showAll)}>
              {showAll ? "View Less" : "View All"}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

RecommendedActionSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  recommendedActions: PropTypes.array,
  icon: PropTypes.string,
  iconKit: PropTypes.string,
  type: PropTypes.string,
};

export default RecommendedActionSection;
